import React from 'react';
import { Divider, Dropdown, MenuProps } from 'antd';
import { ReactComponent as LogoutIcon } from '@blink/assets/src/icons/logout.svg';
import { ReactComponent as UserIcon } from '@blink/assets/src/icons/user.svg';
import { ReactComponent as UsersIcon } from '@blink/assets/src/icons/users.svg';
import { Api, ButtonStroke } from '@blink/components';
import { useSelector } from 'react-redux';
import { LOCAL_STORAGE, LocalStorage } from '@blink/components/src/utils';

import { useUseControlsStyles } from './UserControls.style';
export const UserControls: React.FC = () => {
    const classes = useUseControlsStyles();

    const logout =
        `${Api.API_AUTH_ENDPOINT}/sign_out?rd=` +
        encodeURIComponent(
            `${Api.OAUTH_IDP_LOGOUT_ENDPOINT}?client_id=${Api.API_AUTH_CLIENT_ID}&returnTo=${window.location.origin}`,
        );

    const meInfo = useSelector((state: any) => state.organization.info);
    const organizationName = meInfo?.organization?.name;

    const handleLogout = () => {
        LocalStorage.setItem(LOCAL_STORAGE.LOGGED_IN, '');
        window.location.href = logout;
    };

    const navigateToTeam = () => {
        if (organizationName) {
            window.location.href = '/team';
        }
    };

    const items: MenuProps['items'] = [
        {
            type: 'divider',
        },
        organizationName && {
            key: '1',
            label: (
                <div className={classes.wrapper} onClick={navigateToTeam}>
                    <div className={classes.label}>Team</div>
                    <div className={classes.textButton}>
                        <UsersIcon />
                        {organizationName}
                    </div>
                </div>
            ),
        },
        {
            type: 'divider',
        },
        {
            key: '2',
            label: <div className={classes.textButton}>Log out</div>,
            icon: <LogoutIcon />,
            onClick: handleLogout,
        },
    ];

    const menuStyle: React.CSSProperties = {
        boxShadow: 'none',
    };

    return (
        <Dropdown
            menu={{ items }}
            overlayClassName={classes.dropdownWQL}
            dropdownRender={(menu) => (
                <div>
                    <div className={classes.info}>
                        <div className='name'>{meInfo.name}</div>
                        <div>{meInfo.email}</div>
                    </div>
                    <Divider style={{ margin: 0 }} />
                    {React.cloneElement(menu as React.ReactElement, { style: menuStyle })}
                </div>
            )}
        >
            <ButtonStroke
                data-testid={`user-control-${meInfo.name}`}
                className={classes.root}
                onClick={(e) => e.preventDefault()}
            >
                <UserIcon />
                {meInfo.name}
            </ButtonStroke>
        </Dropdown>
    );
};
